<script lang="ts">
    import { Upload } from 'lucide-svelte';
    import { Button } from "$lib/components/ui/button/index.js";
    import * as Popover from "$lib/components/ui/popover/index.js";
    import { documentUploads } from '$src/infrastructure/projects/documents/uploadDocumentStore';
    import { t  } from 'svelte-i18n'
</script>


<Popover.Root open={true}>
    <Popover.Trigger asChild let:builder>
        <Button builders={[builder]} variant="outline">
            <Upload />
        </Button>
    </Popover.Trigger>
    <Popover.Content class="w-80 bg-secondary text-secondary-foreground">
        <div class="grid gap-4">
            <div class="space-y-2">
              <h4 class="font-medium leading-none">
                {$t('page.projects.documents.active-uploads')}
              </h4>
              {#if $documentUploads.some(upload => upload.error) }
                <Button variant="link">
                    {$t('page.projects.documents.clear-errors')}
                </Button>
              {/if}
            </div>
            <div class="grid gap-2">
                <div class="pb-0">
                    <div class="flex flex-col">
                        {#each $documentUploads as upload}
                            <p class="font-semibold text-xs">{upload.name}</p>
                            {#if upload.error}
                                <p class="text-red-500 text-sm mb-2">{upload.error}</p>
                            {:else}
                                <div class="relative w-full h-2 bg-secondary rounded-full overflow-hidden">
                                    <div class="absolute inset-0 bg-secondary-foreground" style="width: {upload.progress}%;"></div>
                                    <div class="absolute inset-0 flex items-center justify-center">
                                    </div>
                                </div>
                            {/if}
                        {/each}
                    </div>
                </div>
            </div>
          </div>
    </Popover.Content>
  </Popover.Root>